<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M14.5,5.000000527992249C14.5,5.000000527992249,7.89,5.000000527992249,7.89,5.000000527992249C8.3,4.420000527992249,9.1,3.4500005279922483,9.19,2.5300005279922484C9.34,0.9699998279922485,8.12,0.7100005279922486,7.87,1.2800005279922486C7.2,2.8200005279922484,5.19,4.270000527992249,3.92,4.980000527992249C1.95,5.890000527992249,0,6.070000527992248,0,9.860000527992248C0,11.950010527992248,0.61,13.290010527992248,2.12,14.080010527992249C3.36,14.730010527992249,5.21,15.000010527992249,7.83,15.000010527992249C7.83,15.000010527992249,8.62,15.000010527992249,8.62,15.000010527992249C9.27,15.000010527992249,9.8,14.400010527992249,9.8,13.650010527992249C9.8,13.31001052799225,9.69,13.010010527992248,9.51,12.770010527992248C9.99,12.600010527992248,10.35,12.090010527992249,10.35,11.480010527992249C10.35,11.070010527992249,10.19,10.700000527992248,9.93,10.450000527992248C10.3,10.220000527992248,10.56,9.780000527992248,10.56,9.260000527992249C10.56,8.690000527992249,10.25,8.210000527992248,9.82,8.010000527992249C9.82,8.010000527992249,10.45,8.000000527992249,10.45,8.000000527992249C10.45,8.000000527992249,14.5,8.000000527992249,14.5,8.000000527992249C15.33,8.000000527992249,16,7.330000527992248,16,6.500000527992248C16,5.670000527992249,15.33,5.000000527992249,14.5,5.000000527992249C14.5,5.000000527992249,14.5,5.000000527992249,14.5,5.000000527992249Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'HandRight',
} as DefineComponent
</script>
